import React, { useEffect } from "react";

const AppModal = ({ id = "appModal", children, onClose, closeId = null }) => {
  useEffect(() => {
    const modalEl = document.getElementById(id);
    const handleClose = () => {
      if (onClose) onClose();
    };
    if (modalEl) {
      modalEl.addEventListener("hidden.bs.modal", handleClose);
    }

    return () => {
      if (modalEl) {
        modalEl.removeEventListener("hidden.bs.modal", handleClose);
      }
    };
  }, [id, onClose]);

  return (
    <div className="modal fade" id={id} aria-hidden="true" aria-labelledby={`${id}Label`} tabIndex="-1" data-bs-backdrop="static">
      <div className={`modal-dialog modal-dialog-centered modal-lg`}>
        <div className="modal-content">
          <div className="row">
            <div className="col-12 d-flex justify-content-end p-4">
              <button type="button" className="btn-close" data-bs-dismiss="modal" {...(closeId ? { id: closeId } : {})} aria-label="Close" />
            </div>
          </div>
          <div className="modal-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default AppModal;
